if ($('.js-stickyImage').length > 0) {
	$(window).on('load resize', function() {
		let marginTop = $(window).height() / 2 - $('.header').height();
		let position = $(window).scrollTop();

		$('.js-stickyImage').each(function() {
			const _this = $(this);
			const imgHeight = _this.height();
			const parent = _this.parent();
			const index = parent.index();
			const boxHeight = _this.parents('.js-boxWrap').find('.skills-box').eq(index).outerHeight();
			let start = _this.offset().top;
			let finish = start + boxHeight;

			_this.attr('data-start', start);
			_this.attr('data-finish', finish);
			_this.parents('.js-boxWrap').attr('data-height', _this.parents('.js-boxWrap').outerHeight());
			_this.parents('.js-boxWrap').attr('data-offset', _this.parents('.js-boxWrap').offset().top);

			parent.css('height', boxHeight);
		});
	});

	function calcScroll() {
		let pos = $(window).scrollTop();
		let center = $(window).height() / 2 - $('.header').height();

		pos = pos + center;

		$('.js-boxWrap .js-stickyImage').each(function() {
			let _this = $(this);
			let start = _this.data('start');
			let finish = _this.data('finish');
			let parentHeight = _this.parents('.js-boxWrap').data('height') - _this.height();
			let trigger = _this.parents('.js-boxWrap').data('offset') + parentHeight;

			if (pos >= start) {
				_this.addClass('fixed');
				_this.css('top', center);

				if (pos >= trigger) {
					_this.removeClass('fixed');

					_this.parents('.js-boxWrap').addClass('trigger_finish');
				} else {
					_this.parents('.js-boxWrap').removeClass('trigger_finish');
				}

			} else {
				_this.removeClass('fixed');
				_this.css('top', 0);
			}
		});
	}

	$(window).on('load scroll resize', function() {
		calcScroll();
	})
}